module.exports = __webpack_public_path__ + "4040813d4a04f47448d41fd470e1608a.pdf";